<template>
  <div class="boxLogin">
    <div class="title">欢迎登录</div>
    <div class="line">
      <div class="lineRight">
        <el-input type="primary" v-model="username" size="small" placeholder="请输入账号"></el-input>
      </div>
    </div>
    <div class="line">
      <div class="lineRight">
        <el-input type="password" v-model="password" size="small" placeholder="请输入密码"></el-input>
      </div>
    </div>
<!--    <div class="line">-->
<!--      <div class="lineRight">-->
<!--        <el-input  type="primary" size="small" v-model="yzm" placeholder="填写验证码"></el-input>-->
<!--      </div>-->
<!--      <div class="lineRight1" @click="sendYzmMy">-->
<!--        {{yuTime==0?"获取验证码":yuTime}}-->
<!--      </div>-->
<!--    </div>-->
    <div class="buttonBox">
      <el-button @click="doLoginMy" type="primary" style="border:none;background-color: #1d8d05;width: 100%;margin: 0;">
        登录
      </el-button>
      <el-button @click="toRegister" type="primary" style="width: 100%;margin: 0;margin-top: 7px">
        去注册
      </el-button>
      <el-button type="primary" style="width: 100%;margin: 0;margin-top: 7px" @click="closeMy">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import {sendYzm} from "@/api/qt/sendYzm";
import {Message} from "element-ui";
import {doLogin} from "@/api/qt/login";

export default {
    data(){
      return {
        username:"",
        password:"",
        yuTime:0,
        sendYzmOpen:true,
        yzm:"",
        userInfo:{}
      }
    },

  methods: {
     toRegister(){
       this.$emit("closeLogin")
       this.$emit("openRegister")
     },
      closeMy(){
        this.$emit("closeLogin")
      },
     doLoginMy(){
        doLogin(this.username,this.password).then(res=>{
          let data=res.data;
          if(data.code==1){
            localStorage.setItem("token",data.data);
            this.closeMy()
            Message("登录成功")
            window.location.reload()
          }else{
            Message(data.msg)
          }
        })
     },
     async sendYzmMy(){
       if(this.phone==""){
         Message("请输入手机号");
         return;
       }
       if(this.sendYzmOpen==false){
         return;
       }
       this.sendYzmOpen=false;
       let re=await sendYzm(this.phone,'register')
       console.log(re,"发送验证码返回")
       this.yuTime=60;
       let timer=setInterval(()=>{
         this.yuTime--;
         if(this.yuTime==0){
           this.sendYzmOpen=true;
           clearInterval(timer)
         }
       },1000)
     }
   }
 }
</script>
<style scoped>
.lineRight1{
  width:90px;
  font-size: 14px;
  padding-left: 10px;
  box-sizing: border-box;
  color:#aaa;
  cursor: pointer;
}
.title{
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #fff;
}
  .boxLogin{
    width: 400px;
    position: fixed;
    left:calc(50% - 200px);
    top:200px;
    background-color: rgba(44,62,80,0.9);
    padding: 20px;
    border-radius: 10px;
    z-index:111111111;
  }
  .line{
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .buttonBox{
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .line > span{
    width:70px;
    text-align: right;
    padding-right: 10px;
    box-sizing: border-box;
    font-size: 14px;
  }
  .lineRight{
    width:1px;
    flex:1;
  }
</style>
